import React, { useEffect, useRef, useState } from 'react'
import './my-currency-earnings-list.styles.scss';
import ThreeDotsLoader from '@/components/loader/three-dots-loader.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import { format } from 'date-fns';
import BackButton from '@/components/SHARED/back-button/back-button.component';
import { useNavigate } from 'react-router-dom';
import PlayerNameIcon from '../player-name-icon.component';
import { useSelector } from 'react-redux';
import { getGameActivityFromDb } from '@/utils/getDataFromDb';
import PlayerEarningsList from '../player-earnings-list.component';

const MyCurrencyEarningsList = ({ 
    gameData,
    playerData, 
    gameElements, 
    playerActivity, 
    total
}) => {
    
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [ loading, setLoading ] = useState(true);
    const [ sortedList, setSortedList ] = useState([]);
    const navigate = useNavigate();
    const dataRef = useRef();
    
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000)

        return () => {
            if (timer) clearTimeout(timer);
        }
    }, [])

    useEffect(() => {
        if (!playerData || !gameElements) return;
        getCurrencyEarningsList();
    }, [playerData, gameElements]);

    function getCurrencyEarningsList() {
        getGameActivityFromDb({
            "gameId": playerData.gameId,
            "playerId": playerData.playerId,
            "elementId": 'currency',
            "once": true,
            "callback": callback,
        })
        function callback(data) {
            dataRef.current = {
                ...dataRef.current,
                ...data
            }
            setSortedList(Object.values(dataRef.current));
            setLoading(false);
        }
    }

    return (
        <div className='currency-earnings-list'>
            {
                (playerData) && 
                    <div className='g-card list-card'>
                        <BackButton cancel={() => navigate(-1)} />
                        <div>
                            <div className='card-title split'>
                                My {total ? 'Total Currency Earnings' : 'Current Statement'}
                            {
                                (location.pathname.includes('/manage/')) &&
                                <PlayerNameIcon player={playerData} />
                            }
                        </div>
                        <div className="g-space-1"></div>
                        <hr className='no-margin'/>
                        <div className="g-space-0-5"></div>
                        {
                            (playerData) &&
                            <div className='summary meta'>
                                <div className='info'>
                                    Balance: 
                                    <ImageContainer src='/images/icons/coin.png' className='summary-icon' />
                                    <b>{playerData.currency.toLocaleString()}</b>
                                </div>
                                <div className='info'>
                                    Total Earnings: 
                                    <ImageContainer src='/images/icons/coin.png' className='summary-icon' />
                                    <b>{playerData.currencyTotal.toLocaleString()}</b>
                                </div>
                            </div>
                        }
                    </div>
                    {
                        (gameData && playerData && gameElements) && 
                        <PlayerEarningsList
                            gameData={gameData}
                            playerData={playerData}
                            gameElements={gameElements}
                            type='currency'
                            noNegative={total} />
                    } 
                    {/* {
                        (loading)
                        ?
                        <div className='center-col'><ThreeDotsLoader /></div>
                        :
                        (sortedList)
                        ?
                        sortedList
                        .sort((a, b) => b.ts - a.ts)
                        .map(a => {
                            if (a.type === 'purchase' && !total) {
                                console.log(a);
                                return (
                                    <div key={a.ts} className={`g-list-item purchase-item ${screenSize}`}>
                                        <ImageContainer src={a.icon} className='icon' />
                                        <div className='info'>
                                            <div className='title'>
                                                <ImageContainer src='/images/icons/coin.png' />
                                                <div className='purchase'>
                                                    -${a.cartTotal} Spent
                                                </div>
                                            </div>
                                            <div className='meta'>
                                                {a.event}
                                            </div>
                                            <div className='meta'>
                                                {format(new Date(a.ts), "Pp")}
                                            </div>
                                        </div>
                                        <div className='buttons'>
                                            <button 
                                                className='g-button small-btn'
                                                onClick={() => navigate(`/play/${gameData.path}/transaction/${a.path}`)}>View</button>
                                        </div>
                                    </div>
                                )
                            } else if (a.type !== 'purchase') {
                                const data = Object.values(a.data).filter(a => a.type === 'currency')[0];
                                return (
                                    <div key={a.ts} className={`g-list-item currency-item ${screenSize}`}>
                                        <div className='icon-div'>
                                            <ImageContainer src={a.icon} className='icon' />
                                            <div className='info'>
                                                <div className='title'>
                                                    <ImageContainer src='/images/icons/coin.png' />
                                                    {data.title}
                                                </div>
                                                <div className='meta'>
                                                    {a.event}<br />
                                                    {format(new Date(a.ts), "Pp")}
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            (a.comments)
                                            ?
                                            <div className='comment meta'>
                                                Comments:<br /><b>"{a.comments}"</b>
                                            </div>
                                            :
                                            (a.info)
                                            ?
                                            <div className='comment meta'>
                                                Info:<br /><b>{a.info}</b>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                )
                            }
                        })
                        : 
                        <h4 className='center-col'>
                            No earnings yet...
                        </h4>
                    } */}
                </div>
            }
            <div className="g-space-2"></div>
        </div>
    )
}

export default MyCurrencyEarningsList